import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './CourseLevel.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import RowCourseLevel from './RowCourseLevel/RowCourseLevel'
import CourseLevelModal from './CourseLevelModal/CourseLevelModal'
import Loader from 'components/UI/Loader/Loader'

const initPagination = {
  page: 1,
  limit: 10,
}

const CourseLevel = () => {
  const [courseLevel, setCourseLevel] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const fetchCourse = () => {
    superAxiosRequest({
      method: 'get',
      link: 'groups/courselevels',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setCourseLevel(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    // setProgram(null),
    setLoading(true)
    fetchCourse()
  }, [pagination])

  const onBeforeSubmitClient = (data) => {
    const { name, company, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
      ...(company && { company: data.company }),
    }
  }

  const addCourseLevel = () => {
    const ms = {
      modalBodyComponent: () => <CourseLevelModal />,
      button: 'Save',
      link: 'groups/courselevels',
      title: 'Add course level',
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchCourse()
      },
      valid: {
        name: 'required',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const editCourseLevel = (data) => {
    const ms = {
      modalBodyComponent: () => <CourseLevelModal />,
      button: 'Save',
      link: `groups/courselevels/${data?.id}`,
      title: 'Edit course level',
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setCourseLevel((prev) => {
          return {
            ...prev,
            result: prev.result.map((program) =>
              program.id === data.id ? { ...program, ...data } : program,
            ),
          }
        })
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteCourseLevel = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the course level?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `groups/courselevels/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          // setCourseLevel(courseLevel.result.filter(el => el?.id !== data?.id))
          setCourseLevel((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editCourseLevel(items)],
      ['delete', () => deleteCourseLevel(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={'Course level'}>
          <HeaderAddButton
            title={'Add course level'}
            onClick={addCourseLevel}
          />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            Entries: {courseLevel?._meta?.count_items}
          </div>
          <div>
            {courseLevel?.result?.map((level, index) => (
              <RowCourseLevel
                key={level.id}
                level={level}
                index={index}
                action={action}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {courseLevel?._meta?.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={courseLevel?._meta?.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default CourseLevel
